<div class="help">
	<div class="header">
		<div class="left">
			<i class="material-icons-outlined">live_help</i>
			<h5 class="title">{{ labels().HELP_COMPONENT_TITLE }}</h5>
		</div>
		<i data-testid="SUBSYS2_HELP_CLOSE_BTN" class="material-icons-outlined close" (click)="activeModal.close()"
			(keypress)="activeModal.close()">close</i>
	</div>
	<div class="content">
		@if (safeUrl) {
		<iframe data-testid="SUBSYS2_HELP_IFRAME" style="width: 100%; height: 99%;" [src]="safeUrl"
			title="help content"></iframe>
		}
	</div>
</div>